import React, { FunctionComponent, useMemo } from 'react';
import { Col, createArrayInRange, Link, Row } from '@visalex/core';

import cx from 'clsx';
import { Trans, useTranslation } from 'next-i18next';

import styles from './WhatOffer.module.scss';

const WhatOffer: FunctionComponent = () => {
  const { t, i18n } = useTranslation();

  const workVisaTypes = useMemo(
    () =>
      createArrayInRange(0, 5).map((index) => ({
        key: index,
        name: t(`work-visa.what-we-offer.visa-types.${index}.name`),
        description: t(`work-visa.what-we-offer.visa-types.${index}.description`),
        link: t(`work-visa.what-we-offer.visa-types.${index}.link`),
      })),
    [i18n.language]
  );

  return (
    <section className={styles['what-offer']}>
      <Row className={styles['what-offer__title']}>
        <Col xl={8} className="mx-auto">
          <h3 className="text-lg-center">{t('work-visa.what-we-offer.title')}</h3>
        </Col>
      </Row>
      <Row>
        <Col xl={12} className="mx-auto">
          <Row>
            {workVisaTypes.map((visaType) => (
              <Col xs={12} md={6} lg={4} key={visaType.key}>
                <Link href={visaType.link ? `${visaType.link}` : '/green-cards'} className={styles['visa-type']}>
                  {visaType.link ? (
                    <>
                      <h6 className={styles['visa-type__name']}>{visaType.name}</h6>
                      <span className={styles['visa-type__link']}>{visaType.description}</span>
                    </>
                  ) : (
                    <>
                      <h6 className={cx(styles['visa-type__name'], styles['visa-type__name-small'])}>
                        {visaType.name}
                      </h6>
                      <span className={styles['visa-type__description']}>
                        <Trans i18nKey={`work-visa.what-we-offer.visa-types.${visaType.key}.description`}>
                          Check out our <span className={styles['visa-type__link']}>Green Card</span> solution.
                        </Trans>
                      </span>
                    </>
                  )}
                </Link>
              </Col>
            ))}
          </Row>
        </Col>
      </Row>
    </section>
  );
};

export default WhatOffer;
